import { useCallback, useEffect, useState } from 'react'
import ModalTabs from '../../../../../../baseComponents/ModalsLayouts/ModalTabs'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { ComponentTabObject } from '../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { EditVariantsGeneral } from './Tabs/EditVariantsGeneral'
import EditVariantsPrices from './Tabs/EditVariantsPrices'
import EditVariantsImages from './Tabs/EditvariantsImages'
import { ProductExtendedTyShort } from '../../../../types'

interface ModalEditProductVariantsProps extends ModalEditComponentProps { }

const ModalEditProductVariants: React.FC<ModalEditProductVariantsProps> = ({ userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    const { productVariants } = useModalEditProductVariantsLogic({ProductId: rest?.allRowData?.id })
    if (!userPermissions) {
        return null
    }
    const tabs: ComponentTabObject = {
        'main': { component: EditVariantsGeneral, text: t('generalFields', 'Campos generales') },
        'prices': { component: EditVariantsPrices, text: t('generatePrices', 'Generar precios') },
        'images': { component: EditVariantsImages, text: t('images', 'Imágenes')}
    }
    return (
        <ModalTabs {...rest} tabs={tabs} tab={'main'} className='notFlexAutoFormRender' userPermissions={userPermissions} extraComponentData={{ items: productVariants || [], onSubmit: rest.onSubmit }} isLoading={!productVariants}></ModalTabs>
    )
}

interface ModalEditProductVariantsLogicProps {
    ProductId: number
}

const useModalEditProductVariantsLogic = ({ ProductId }: ModalEditProductVariantsLogicProps) => {
    const [productVariants, setProductVariants] = useState<ProductExtendedTyShort[] | null>(null)
    const getProductVariants = useCallback(async() => {
        let result = await twinFetchPostJSON('/api/app/product/getAllProductsWithSubProductsComplete', { where: { 'Product.ProductId': ProductId }, order: [['id', 'asc']] })
        if (result) {
            setProductVariants(result)
        }
    }, [ProductId])

    useEffect(() => {
        getProductVariants()
    }, [getProductVariants])

    return { productVariants }
}


export default ModalEditProductVariants